module.exports = __webpack_public_path__ + "img/buy_requests.51735593.svg";